// Latest Update
export const GDSC_Lead = [
  {
    name: "Aman Singh Bhogal",
    image: "/images/2022 Team/aman.jpg",
    role: "GDSC Lead",
    insta: "https://www.instagram.com/asb_0002/?hl=en",
    linkedin: "https://www.linkedin.com/in/aman-singh-bhogal-002914195/",
  },
];

export const Event_Team = [
  {
    name: "Shubham Gandhi",
    image: "/images/2022 Team/Shubham Gandhi.jpg",
    role: "",
    insta: "https://instagram.com/shubham.gandhii?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/shubham-gandhi-283582222",
  },
  {
    name: "Jhanvi Bhalodia",
    image: "/images/2022 Team/Jhanvi Bhalodia .jpg",
    role: "",
    insta: "",
    linkedin: "https://www.linkedin.com/in/jhanvi-bhalodia-9b9841231",
  },
  {
    name: "Vaishnavi Choubey",
    image: "/images/2022 Team/Vaishnavi Choubey.jpg",
    role: "",
    insta: "https://www.instagram.com/vaishhhh_27/",
    linkedin: "https://www.linkedin.com/in/vaishnavi-choubey-5142a9220",
  },
  {
    name: "Manishka Pareta",
    image: "/images/2022 Team/MANISHKA PARETA.jpg",
    role: "",
    insta: "https://instagram.com/manishkapareta?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/manishka-pareta-4816121ba",
  },
  {
    name: "Nishtha Desai",
    image: "/images/2022 Team/Nishtha Desai .jpg",
    role: "",
    insta: "https://instagram.com/nishtha_desai6?igshid=YmMyMTA2M2Y=",
    // "linkedin": 'https://www.linkedin.com/in/muskan-chopra-787b29199'
  },
  {
    name: "Prashansa Saxena",
    image: "/images/2022 Team/Prashansa Saxena.jpg",
    role: "",
    insta: "http://instagram.com/_prashansaaaa_",
    linkedin: "https://www.linkedin.com/in/prashansa-saxena-1a4a94250",
  },
  {
    name: "Rudra kabrawala",
    image: "/images/2022 Team/Rudra_kabrawala.jpg",
    role: "",
    insta: "https://instagram.com/rudra_274?igshid=MDE2OWE1N2Q=",
    linkedin: "https://www.linkedin.com/in/rudra-kabrawala-a2a106249",
  },
  {
    name: "Akshat Mankar",
    image: "/images/2022 Team/Akshat Mankar.jpg",
    role: "",
    // "insta": '/',
    linkedin: "/",
  },
];

export const Marketing_Team = [
  {
    name: "Jensy Aya",
    image: "/images/2022 Team/jensy.jpg",
    role: "Marketing Lead",
    insta: "https://instagram.com/jensy20_07?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/jensy-aya-054109227/",
  },
  {
    name: "Dhruvi Agrawal",
    image: "/images/2022 Team/Dhruvi Agrawal.jpg",
    role: "",
    insta: "https://instagram.com/_dhruvi312_?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/dhruvi-agrawal-09823522b",
  },
  {
    name: "Krrish Juneja",
    image:
      "https://raw.githubusercontent.com/GDSC-MPSTME-Shirpur/GDSC-MPSTME-Website/master/public/images/2022%20Team/Krrish%20juneja%20.jpg",
    role: "",
    insta: "https://www.instagram.com/junejakrrish/",
    linkedin: "https://www.linkedin.com/in/krrish-juneja-470b981a8/",
  },
  {
    name: "Aryan Pastagia",
    image: "/images/2022 Team/Aryan Pastagia .jpg",
    role: "",
    insta: "https://www.instagram.com/aryan_pastagia/?hl=en",
    linkedin: "https://www.linkedin.com/in/aryan-pastagia-50454a248",
  },
  {
    name: "Anjali Sharma",
    image: "/images/2022 Team/ANJALI SHARMA.jpg",
    role: "SPTM Shirpur",
    insta: "https://instagram.com/ani_jsharma?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/mwlite/in/anjali-sharma-55050b220",
  },
  {
    name: "Gunamrutha Kode",
    image: "/images/2022 Team/Gunamrutha Kode.jpg",
    role: "",
    insta: "https://www.instagram.com/gunamruthak/",
    linkedin: "https://www.linkedin.com/in/gunamrutha-kode-84b1a9233",
  },

  {
    name: "Ayushi Verma",
    image: "/images/2022 Team/Ayushi Verma.jpg",
    role: "",
    insta: "https://instagram.com/_.aaayyuushiii._?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/ayushi-verma-95198724a",
  },
  {
    name: "Vaibhav Patil",
    image: "/images/2022 Team/VAIBHAV PATIL .PNG",
    role: "",
    // "insta": '/',
    linkedin: "https://www.linkedin.com/in/vaibhav-patil-b3016a249",
  },
  {
    name: "Owais Bubere",
    image: "/images/2022 Team/Owais Bubere.jpg",
    role: "",
    insta: "https://www.instagram.com/imnotowais",
    linkedin: "https://www.linkedin.com/in/owais-bubere-b50950250",
  },
];

export const Tech_Team = [
  {
    name: "Vasu Choudhary",
    image: "/images/2022 Team/vasu.jpg",
    role: "Technical Lead",
    insta: "https://www.instagram.com/vasu0508/",
    linkedin: "https://www.linkedin.com/in/vasu-choudhary-59a3b0176/",
  },
  {
    name: "Sameep Hedaoo",
    image: "/images/2022 Team/Sameep Hedaoo.jpg",
    role: "",
    insta: "https://www.instagram.com/iamsameep/",
    linkedin: "https://www.linkedin.com/in/sameep-hedaoo-35475222b/",
  },
  {
    name: "Jenil Dhorajiya",
    image: "/images/2022 Team/Jenil Dhorajiya .jpg",
    role: "",
    insta: "https://www.instagram.com/jenil_7/",
    linkedin: "https://www.linkedin.com/in/jenil-dhorajiya-5551521b5/",
  },
  {
    name: "Kunal Patil",
    image: "/images/2022 Team/Kunal Patil.jpg",
    role: "",
    insta: "https://www.instagram.com/kunal.patil.03/?igshid=YmMyMTA2M2Y%3D",
    linkedin: "https://www.linkedin.com/in/kunal-patil-4ba636218/",
  },
  {
    name: "Yash Sutaria",
    image:
      "https://raw.githubusercontent.com/GDSC-MPSTME-Shirpur/GDSC-MPSTME-Website/master/public/images/2022%20Team/Yash%20Sutaria.JPG",
    role: "",
    insta: "https://www.instagram.com/yash_sutaria/",
    linkedin: "https://www.linkedin.com/in/yash-sutaria-4389b71b6/",
  },
  {
    name: "Tanish Singh Rajpal",
    image: "/images/2022 Team/Tanish Singh Rajpal.jpeg",
    role: "",
    insta: "",
    linkedin: "https://www.linkedin.com/in/tanish-singh-rajpal-25967121a",
  },
  {
    name: "Khushvardhan Bhardwaj",
    image: "/images/2022 Team/Khushvardhan Bhardwaj .jpg",
    role: "",
    insta: "https://www.instagram.com/khushvardhanbhardwaj/",
    linkedin: "https://www.linkedin.com/in/khushvardhan-bhardwaj-a399b1213/",
  },
  {
    name: "Aman Singh Bhadoriya",
    image: "/images/2022 Team/Aman_Singh_Bhadoriya.jpg",
    role: "",
    insta: "",
    linkedin: "https://www.linkedin.com/in/aman-singh-bhadoriya-6ab6841ba/",
  },
  {
    name: "Jayvardhan Bhardwaj",
    image: "/images/2022 Team/Jayvardhan Bhardwaj .jpg",
    role: "",
    insta: "https://www.instagram.com/jayvardhanbhardwaj/",
    linkedin: "https://www.linkedin.com/in/jayvardhan-bhardwaj-485a5a1b2/",
  },
  {
    name: "Amit Agarwal",
    image: "/images/2022 Team/Amit Agarwal.jpg",
    role: "",
    insta: "https://www.instagram.com/amitagarwal2312",
    linkedin: "https://www.linkedin.com/in/amit-agarwal2267",
  },
  {
    name: "Amit Upadhyay",
    image: "/images/2022 Team/Amit Upadhyay.jpeg",
    role: "",
    insta: "https://www.instagram.com/ppl_call_me_tima/",
    linkedin: "https://www.linkedin.com/in/amit-upadhyay-5322a8249",
  },
  {
    name: "Jiya Garg",
    image: "/images/2022 Team/Jiya Garg.jpg",
    role: "",
    insta: "https://instagram.com/jiya.garg_?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/jiya-garg-2ab348239",
  },
];

export const Creative_Team = [
  {
    name: "Krishna Pande",
    image: "/images/2022 Team/krishna_pande.jpeg",
    role: "Creative Lead",
    insta: "https://www.instagram.com/_krishna_pande1904/",
    linkedin: "https://www.linkedin.com/in/krishna-pande-a6a9b6211",
  },
  {
    name: "Keyush Shah",
    image: "/images/2022 Team/KEYUSH SHAH.jpg",
    role: "",
    insta: "https://www.instagram.com/keyush_2002/?hl=en",
    linkedin: "https://www.linkedin.com/in/keyush-shah-b98b08193/",
  },
  {
    name: "Sayli Karwade",
    image: "/images/2022 Team/Sayli Karwade.jpeg",
    role: "",
    insta: "https://www.instagram.com/saylikarwade/",
    linkedin: "https://www.linkedin.com/in/sayli-karwade-6860b7225/",
  },
  {
    name: "Jonty Bhalodiya",
    image: "/images/2022 Team/Jonty-Bhalodiya.jpeg",
    role: "",
    insta: "https://www.instagram.com/jontybhalodiya/?hl=en",
    linkedin: "https://www.linkedin.com/in/jontybhalodiya/",
  },
  {
    name: "Charyan Sharma",
    image: "/images/2022 Team/Charyan.jpg",
    role: "",
    insta: "https://instagram.com/c.yan_sharma?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/charyan-sharma-66646421a",
  },
  {
    name: "Varsha Poswalia",
    image: "/images/2022 Team/Varsha Poswalia.jpg",
    role: "",
    insta: "https://www.instagram.com/ayyyvarsha/?hl=en",
    linkedin: "https://www.linkedin.com/in/varsha-poswalia-506522223",
  },
  {
    name: " Diya Gandhi",
    image: "/images/2022 Team/Diya gandhi.jpg",
    role: "",
    insta: "https://www.instagram.com/diya_gandhi16/?hl=en",
    linkedin: "https://www.linkedin.com/in/diya-gandhi-09100820b",
  },
  {
    name: "Suhani Gupta",
    image: "/images/2022 Team/Suhani Gupta.jpg",
    role: "",
    insta: "https://www.instagram.com/suhani_agrawal001/?igshid=YmMyMTA2M2Y%3D",
    linkedin: "https://www.linkedin.com/in/suhani-gupta-1b216522a",
  },
  {
    name: "Manushri",
    image: "/images/2022 Team/Manushri.jpg",
    role: "",
    insta: "https://instagram.com/_manushri_1277?igshid=YmMyMTA2M2Y=",
    linkedin: " https://www.linkedin.com/in/manushri-90535b231",
  },

  {
    name: "Soniya Kamat",
    image: "/images/2022 Team/Soniya Kamat.webp",
    role: "SPTM Shirpur",
    insta:
      "https://www.instagram.com/p/Cb2LKpRgY21_tQX4oWZ9pjZeyZtkHVVQFAtReI0/?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/soniya-kamat-417723242",
  },

  {
    name: "Diya Agarwal",
    image: "/images/2022 Team/Diya Agarwal .JPG",
    role: "",
    insta: "https://instagram.com/diyaagarwal__?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/diya-agarwal-33aa88250",
  },

  {
    name: "Sanket kolpyakwar",
    image: "/images/2022 Team/Sanket kolpyakwar.jpg",
    role: "",
    insta: "https://instagram.com/sannket_88?igshid=YmMyMTA2M2Y=",
    // "linkedin": 'https://www.linkedin.com/in/soniya-kamat-417723242'
  },

  {
    name: "Pranjal galundia",
    image: "/images/2022 Team/Pranjal galundia .jpg",
    role: "",
    insta: "https://www.instagram.com/pranjalgalundia/",
    linkedin: "https://www.linkedin.com/in/pranjal-galundia-10195b24a",
  },

  {
    name: "Yug Desai",
    image: "/images/2022 Team/Yug Desai.jpeg",
    role: "",
    insta: "https://instagram.com/its_me_yug._?igshid=NmNmNjAwNzg=",
    linkedin: "http://www.linkedin.com/in/yug-desai-2b5064251",
  },
];

export const PR_Team = [
  {
    name: "Aarya Mehta",
    image: "/images/2022 Team/Aarya Mehta.jpg",
    role: "",
    insta: "https://instagram.com/_aaryamehta_?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/aarya-mehta-4247611b9",
  },
  {
    name: "Khushi Ajmera",
    image: "/images/2022 Team/Khushi Ajmera.jpg",
    role: "",
    insta: "https://www.instagram.com/_khushii.a/",
    linkedin: "https://www.linkedin.com/in/khushi-ajmera-2b84a3224/",
  },
  {
    name: "Ishika Mahajan",
    image: "/images/2022 Team/ishika.jpg",
    role: "",
    // "insta": '/',
    linkedin: "https://www.linkedin.com/in/ishika-mahajan-313072245",
  },
  {
    name: "Kaushal Kuwar",
    image: "/images/2022 Team/Kaushal Kuwar .jpg",
    role: "",
    insta: "http://www.instagram.com/kaushalk05",
    linkedin: "http://www.linkedin.com/in/kaushalkuwar",
  },
  {
    name: "Darshita Anyawada",
    image: "/images/2022 Team/darshita.jpg",
    role: "",
    insta: "https://instagram.com/_darshita_22?igshid=YmMyMTA2M2Y=",
    linkedin: "https://www.linkedin.com/in/darshita-anyawada-95792a222",
  },
  {
    name: "Chirag Vijayvergiya",
    image: "/images/2022 Team/Chirag Vijayvergiya.jpg",
    role: "",
    insta: "https://www.instagram.com/chiragvijayvergiya?r=nametag",
    linkedin: "https://www.linkedin.com/in/chirag-vijayvergiya-548635245",
  },
  {
    name: "Devanshi Ramani",
    image: "/images/2022 Team/Devanshi ramani.jpg",
    role: "",
    insta: "http://instagram.com/devanshii_15",
    linkedin: "https://www.linkedin.com/in/devanshi-ramani-611192234",
  },
];
